// eslint-disable-next-line import/no-unresolved
import Keycloak from 'keycloak-js';

import env from './env';

export default new Keycloak({
    clientId: 'cs-web',
    realm: 'cleveron',
    url: env.REACT_APP_KEYCLOAK_AUTH_URL,
});
